export default "__VITE_ASSET__D1ZDL5pB__"